import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import PlanDesignDetail from './detail';
import { useForm, FormProvider } from 'react-hook-form';
import SubmitButton from 'common/SingleClickButton';

const PlanDesignDataDetailDialog = (props) => {
  const { onClose, open, tenantId, target, category } = props;

  const methods = useForm({
    defaultValues: target,
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });
  const { reset } = methods;

  const [saveDisabled, setSaveDisabled] = useState(false);

  const handleClose = (data) => {
    onClose(data);
  };

  const onSubmit = (data) => {
    onClose(data);
  };

  useEffect(() => {
    reset(target);
  }, [tenantId, open, target]);

  return (
    <>
      <FormProvider {...methods}>
        <Dialog
          open={open}
          onClose={(_, reason) => {
            if (reason !== 'backdropClick') {
              handleClose();
            }
          }}>
          <DialogTitle id="customized-dialog-title">
            {target && target.id > 0 ? 'Edit' : 'New'}
          </DialogTitle>
          <DialogContent dividers>
            <PlanDesignDetail
              tenantId={tenantId}
              isModified={target && target.id > 0}
              targetId={target ? target.id : null}
              category={category}
              setSaveDisabled={setSaveDisabled}
            />
          </DialogContent>
          <DialogActions>
            <SubmitButton
              disabled={saveDisabled}
              handleSubmit={methods.handleSubmit(onSubmit)}
              isDirty={methods.formState.isDirty}
            />
            <Button onClick={() => handleClose(null)} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default PlanDesignDataDetailDialog;
